var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0787 15.7605C12.0058 15.7605 11.1222 16.5335 11.1222 17.4908V31.7203C11.1222 32.6591 12.0058 33.4322 13.0787 33.4322C14.1726 33.4322 15.0563 32.6591 15.0563 31.7203V17.4908C15.0563 16.5335 14.1726 15.7605 13.0787 15.7605Z",
    fill: "#2A4887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1238 8.9677C23.0508 8.9677 22.1673 9.74084 22.1673 10.6981V31.7201C22.1673 32.6589 23.0508 33.4321 24.1238 33.4321C25.2178 33.4321 26.1013 32.6589 26.1013 31.7201V10.6981C26.1013 9.74084 25.2178 8.9677 24.1238 8.9677Z",
    fill: "#2A4887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0215 23.2709C33.9275 23.2709 33.0439 24.0441 33.0439 25.0013V31.7203C33.0439 32.6591 33.9275 33.4322 35.0004 33.4322C36.0943 33.4322 36.978 32.6591 36.978 31.7203V25.0013C36.978 24.0441 36.0943 23.2709 35.0215 23.2709Z",
    fill: "#2A4887"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric);
export default __webpack_public_path__ + "static/media/metric.fa274031e8d5dcc1ddc283d492ee9af8.svg";
export { ForwardRef as ReactComponent };